import React from 'react';
import { SearchRemixer_FacetGroupFieldsFragment } from '@reverbdotcom/commons/src/gql/graphql';
import { RCAccordion } from '@reverbdotcom/cadence/components';
import SearchInputGroup from '@reverbdotcom/commons/src/cms/search_input_group';
import { useUpdateUrl } from '@reverbdotcom/commons/src/components/with_update_url';
import { withRouter, WithRouterProps } from 'react-router';

export interface SearchTermFacetProps {
  facetGroup: SearchRemixer_FacetGroupFieldsFragment;
}

export function SearchTermFacet({
  facetGroup,
  router,
  location,
}: SearchTermFacetProps & WithRouterProps) {
  const [query, setQuery] = React.useState(facetGroup?.facets?.[0]?.paramValue || '');
  const { updateUrl } = useUpdateUrl();

  const handleSubmit = (e) => {
    if (e) e.preventDefault();
    const newUrl = updateUrl({
      location,
      newParams: { [facetGroup.key]: query },
    });
    router.push(newUrl);
  };

  return (
    <div className="facet facet--collapsible" data-testid="search-term-facet">
      <RCAccordion
        id="facet-sidebar-search-term"
        heading={facetGroup.displayName}
        defaultOpen
      >
        <SearchInputGroup
          onSubmit={handleSubmit}
          onChange={(e) => setQuery(e.target.value)}
          onClear={() => setQuery('')}
          value={query}
          id="facet-sidebar-search-term-input"
          hiddenLabel
        />
      </RCAccordion>
    </div>
  );
}

export default withRouter(SearchTermFacet);
